module.exports = "<md-icon class=\"md-primary\">\n  {{::$ctrl.icon}}\n  <md-tooltip md-direction=\"top\">{{::$ctrl.dispTitle}}</md-tooltip>\n</md-icon>\n{{::$ctrl.dispTitle}}:\n<p class=\"mt-2 capitalize\" ng-bind=\"$ctrl.info\"></p>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/dispInfo/dispInfo.html
// module id = 1126
// module chunks = 0